// eslint-disable-line

function countryIsoCodeAlpha2(country) {
  const countryCodeMap = {
    usa: 'US',
    aus: 'AU',
    can: 'CA',
    barbados: 'BB',
    cayman: 'KY',
    nz: 'NZ',
    gb: 'GB',
    spain: 'ES',
    italy: 'IT',
    india: 'IN',
    philippines: 'PH',
    vietnam: 'VN',
    greece: 'GR',
    US: 'US',
    AU: 'AU',
    CA: 'CA',
    BB: 'BB',
    KY: 'KY',
    NZ: 'NZ',
    GB: 'GB',
    ES: 'ES',
    IT: 'IT',
    IN: 'IN',
    PH: 'PH',
    VN: 'VN',
    GR: 'GR',
  }
  return countryCodeMap[country]
}

function countryIsoCodeAlpha3(country) {
  const countryCodeMap = {
    US: 'usa',
    AU: 'aus',
    CA: 'can',
    BB: 'barbados',
    KY: 'cayman',
    NZ: 'nz',
    GB: 'gb',
    ES: 'spain',
    IT: 'italy',
    IN: 'india',
    PH: 'philippines',
    VN: 'vietnam',
    GR: 'greece',
    usa: 'usa',
    aus: 'aus',
    can: 'can',
    cayman: 'cayman',
    barbados: 'barbados',
    nz: 'nz',
    gb: 'gb',
    spain: 'spain',
    italy: 'italy',
    india: 'india',
    philippines: 'philippines',
    vietnam: 'vietnam',
    greece: 'greece',
  }
  return countryCodeMap[country] || null
}

export {countryIsoCodeAlpha2, countryIsoCodeAlpha3}
